import classes from "./ConfirmModal.module.css";
import { t } from "../../i18n";

const ConfirmModal: React.FC<{
  title?: string;
  message: string;
  confirmLabel: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}> = (props) => {
  return (
    <div className={classes.overlay} onClick={props.onCancel}>
      <div className={classes.card} onClick={(event) => event.stopPropagation()}>
        {props.title && <div className={classes.title}>{props.title}</div>}
        <div className={classes.message}>{props.message}</div>
        <div className={classes.actions}>
          <button
            type="button"
            className={classes.cancelButton}
            onClick={props.onCancel}
          >
            {props.cancelLabel ?? t.cancel}
          </button>
          <button
            type="button"
            className={classes.confirmButton}
            onClick={props.onConfirm}
          >
            {props.confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
